import { useState } from 'react';
import {
  Stack,
  Grid,
  Paper,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

import ReleaseCard from './ReleaseCard';
import PreviousReleaseCard from './PreviousReleaseCard';

import { useGetChangelogQuery } from '../../services/ADapi';

const downloadMethods = {
  windows: '/agents/rest_api/v1/build/exe/download/',
  linux: [
    '/agents/rest_api/v1/build/deb/download/',
    '/agents/rest_api/v1/build/rpm/download/',
  ],
};

const Releases = () => {
  const [currentOsName, setOsName] = useState(null);
  const [isDownloadTriggered, setDownloadTriggerState] = useState(false);

  const osNameHandler = (_e, osName) => {
    setOsName(osName);
  };

  const { data = {} } = useGetChangelogQuery();

  const osNames = Object.keys(data);

  const activeOsName = currentOsName ?? osNames[0];

  return (
    <Stack gap={7}>
      <Paper>
        <Typography variant="h1" component="h2" paddingBottom={3}>
          Agent
        </Typography>
        <Grid container spacing={3}>
          {osNames.length > 0 ? (
            osNames.map((osName) => {
              const logs = data[osName];

              if (logs.length === 0) {
                return null;
              }

              const agentVersion = logs[0]?.agent_version;
              const releaseDate = logs[0]?.release_date;
              const changelog = logs[0]?.changelog;

              return (
                <Grid key={osName} item xs={12} md={4}>
                  <ReleaseCard
                    osName={osName}
                    agentVersion={agentVersion}
                    releaseDate={releaseDate}
                    changelog={changelog}
                    downloadMethods={downloadMethods[osName]}
                    isDownloadTriggered={isDownloadTriggered}
                    setDownloadTriggerState={setDownloadTriggerState}
                  />
                </Grid>
              );
            })
          ) : (
            <Grid item xs>
              <Typography variant="body1">No data</Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
      <Paper>
        <Grid container justifyContent="space-between" paddingBottom={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="h1" component="h2" paddingBottom={3}>
              Version history
            </Typography>
          </Grid>
          {osNames.length > 1 ? (
            <Grid item xs={12} md="auto">
              <ToggleButtonGroup
                exclusive
                aria-label="agents changelogs"
                value={activeOsName}
                onChange={osNameHandler}
              >
                {osNames.map((osName) => {
                  if (data[osName]?.length === 0) {
                    return null;
                  }

                  return (
                    <ToggleButton
                      key={osName}
                      value={osName}
                      aria-label={osName}
                      sx={{ textTransform: 'capitalize' }}
                    >
                      {osName}
                    </ToggleButton>
                  );
                })}
              </ToggleButtonGroup>
            </Grid>
          ) : null}
        </Grid>

        <Grid container spacing={6}>
          {data[activeOsName]?.length > 0 ? (
            data[activeOsName].map((log, i) => {
              if (i < 4) {
                return (
                  <Grid key={log.os + log.agent_version} item xs={12} md={6}>
                    <PreviousReleaseCard
                      agentVersion={log.agent_version}
                      releaseDate={log.release_date}
                      changelog={log.changelog}
                    />
                  </Grid>
                );
              }

              return null;
            })
          ) : (
            <Grid item xs>
              <Typography variant="body1">No data</Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Stack>
  );
};

export default Releases;
